exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1hlTg9RcH0ZeY_{margin:8px 0 16px;text-align:center}._2MLvMDbL-Df7E3{margin-bottom:0}", ""]);

// exports
exports.locals = {
	"emptyText": "_1hlTg9RcH0ZeY_",
	"addCoverButton": "_2MLvMDbL-Df7E3"
};